



























































































































































































































import Vue from "vue";
import ApplicationPartList from "@/components/navigation-menu/ApplicationPartList.vue";
import PortalGroupedList from "@/components/PortalGroupedList.vue";
import SimpleList from "@/components/generic/SimpleList.vue";
import FavoritesPortals from "./FavoritesPortals.vue";
import Utils from "@/utils";
import storeHelper from "@/store/store-helper";
import { Portal } from "@infoland/iprova-api";
import { SimpleListItem } from "@/types/simpleListItem";
import { Team } from "@/teams";
import _ from "lodash";
import { PortalMini } from "@/api/PortalMini";
export default Vue.extend({
    name: "ToolbarMenu",
    components: {
        ApplicationPartList,
        PortalGroupedList,
        SimpleList,
        FavoritesPortals
    },
    props: {
        routeName: String,
        portalId: Number,
        isAnonymousUser: Boolean,
        showMenu: Boolean
    },
    data: () => {
        return {
            navigationVisible: false,
            navigationMainComponentsVisible: true,
            allPortalsListIsVisible: false,
            allModuleListIsVisible: false,
            allTeamsListIsVisible: false,
            organizationLogo: "",
            teamUsageEnabled: false,
            searchText: null
        };
    },
    async created() {
        storeHelper.siteStore.loadApplicationParts(); //trigger load but don't wait for it
        this.organizationLogo = await storeHelper.settingsStore.getSettingAsync<string>("organisation_logo");
        this.teamUsageEnabled = await storeHelper.settingsStore.getSettingAsync<boolean>("team_usage_enabled");
    },
    watch: {
        showMenu: {
            handler() {
                this.toggleShowNavigation();
            },
            immediate: false
        },
        navigationVisible: function (newValue: boolean) {
            storeHelper.siteStore.setIsDialogDisplayed(newValue);
        }
    },
    computed: {
        buttonBackToNavigationVisible(): boolean {
            return this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm";
        },
        canAddTeams(): boolean {
            return this.teamUsageEnabled && !Utils.isSystemUser(this.$user.user_id);
        },
        hasTeams(): boolean {
            return storeHelper.teamsStore.teams && storeHelper.teamsStore.teams.length > 0;
        },
        canUseTeams(): boolean {
            return this.teamUsageEnabled && (this.hasTeams || this.canAddTeams);
        },
        isFavoritesPortalsListVisible(): boolean {
            return storeHelper.portalStore.portals && storeHelper.portalStore.portals.length > 1 && this.navigationVisible;
        },
        startPortal(): PortalMini {
            const startPortal = this.$user.start_portal;
            if (startPortal == null) {
                return { portal_id: 0, name: "" };
            } else {
                return startPortal;
            }
        },
        applicationPartsLoaded(): boolean {
            return storeHelper.siteStore.applicationParts !== null;
        },
        noApplicationParts(): boolean {
            return storeHelper.siteStore.applicationParts?.length === 0;
        }
    },
    methods: {
        toggleShowNavigation(): void {
            this.allPortalsListIsVisible = false;
            this.allModuleListIsVisible = false;
            this.allTeamsListIsVisible = false;
            this.navigationVisible = !this.navigationVisible;
            if (this.navigationVisible) {
                this.searchPortals();
                this.getFavoritePortalsList();
            }
        },
        backToMainNavigationClicked(): void {
            this.allPortalsListIsVisible = this.allModuleListIsVisible = false;
            this.navigationMainComponentsVisible = !this.navigationMainComponentsVisible;
        },
        showAllPortalsClicked(): void {
            this.allPortalsListIsVisible = !this.allPortalsListIsVisible;
            this.allModuleListIsVisible = false;
            this.allTeamsListIsVisible = false;

            if (this.buttonBackToNavigationVisible) {
                this.navigationMainComponentsVisible = false;
            }
        },
        showAllModulesClicked(): void {
            this.allModuleListIsVisible = !this.allModuleListIsVisible;
            this.allPortalsListIsVisible = false;
            this.allTeamsListIsVisible = false;
            if (this.buttonBackToNavigationVisible) {
                this.navigationMainComponentsVisible = false;
            }
        },
        showAllTeamsClicked(): void {
            this.allTeamsListIsVisible = !this.allTeamsListIsVisible;
            this.allPortalsListIsVisible = false;
            this.allModuleListIsVisible = false;
            if (this.buttonBackToNavigationVisible) {
                this.navigationMainComponentsVisible = false;
            }
        },
        searchPortals(): Portal[] {
            const text = this.searchText;
            const listOfPortals = [];
            storeHelper.portalStore.portals.forEach(val => listOfPortals.push(Object.assign({}, val)));
            _.mapValues(listOfPortals, (val, key) => {
                val.disabled = val.portal_id == this.portalId;
            });
            if (text != null && text != undefined) {
                return _.filter(listOfPortals, function (o) {
                    return o.name.toLowerCase().indexOf(text.toLowerCase()) > -1;
                });
            }

            return listOfPortals;
        },
        getFavoritePortalsList(): Portal[] {
            let sortedByName = [];
            const clonedPortals = [];
            storeHelper.portalStore.portals.forEach(val => clonedPortals.push(Object.assign({}, val)));
            const lastVisitedPortals = _.filter(clonedPortals, function (o) {
                return o.last_visited_date_time != null;
            });
            if (lastVisitedPortals && lastVisitedPortals.length > 0) {
                const sortedByLastVisited = _.sortBy(lastVisitedPortals, [
                    function (o) {
                        return o.last_visited_date_time.toDate();
                    }
                ])
                    .reverse()
                    .slice(0, 5);
                _.mapValues(sortedByLastVisited, (val, key) => {
                    val.disabled = val.portal_id == this.portalId;
                });

                if (sortedByLastVisited != null && sortedByLastVisited.length > 0) {
                    sortedByName = _.sortBy(sortedByLastVisited, [portal => portal.name.toLowerCase()]);
                }
            }

            if (sortedByName.length > 0) {
                return _.map(sortedByName, function (item): SimpleListItem {
                    return {
                        id: item.portal_id,
                        title: item.name,
                        selected: item.disabled
                    };
                });
            }

            return sortedByName;
        },
        getTeamsList(lastVisited: boolean): Team[] {
            let teams = storeHelper.teamsStore.teams;

            if (lastVisited) {
                let visitedTeams = teams.filter(t => t.last_visited !== undefined);
                let unvisitedTeams = teams.filter(t => t.last_visited === undefined);
                visitedTeams.sort((a, b) => {
                    if (a.last_visited > b.last_visited) return -1;
                    else if (a.last_visited < b.last_visited) return 1;
                    else return 0;
                });

                teams = visitedTeams.concat(unvisitedTeams);
                teams = teams.slice(0, 3);
            }

            if (teams.length > 0) {
                return _.map(teams, function (item): SimpleListItem {
                    return {
                        id: item.team_id,
                        title: item.name
                    };
                });
            }
        },
        teamClicked(item: SimpleListItem): void {
            if (this.routeName !== "Team" || this.$route.params.teamId != item.id)
                if (this.portalId) {
                    this.$router.push({ name: "Team", params: { teamId: item.id as string, portalId: this.portalId.toString() } });
                } else {
                    this.$router.push({ name: "Team", params: { teamId: item.id as string } });
                }
        },
        addTeamClicked(): void {
            this.$router.push({ name: "AddTeam" });
        },
        getRedirectToPortalUrl(portalId: Number): String {
            const routeData = this.$router.resolve({ name: "Portal", params: { portalId: portalId.toString() } });
            return routeData.href;
        },
        redirectToSelectedPortal(portalItem: SimpleListItem): void {
            if (!this.navigationMainComponentsVisible) this.navigationMainComponentsVisible = true;
            if (portalItem.id === 0) {
                if (this.$route.name != "Welcome") this.$router.push({ name: "Welcome" });
                else this.toggleShowNavigation();
            } else {
                if (this.portalId === portalItem.id && this.routeName === "Portal") {
                    this.toggleShowNavigation();
                } else {
                    if (this.routeName !== "Portal" || this.portalId !== portalItem.id) {
                        this.$router.push({ name: "Portal", params: { portalId: portalItem.id.toString() } });
                    }
                }
            }
        },
        logOnClicked(): void {
            Utils.navigateToLogin();
        }
    }
});
